import React from "react";
import "./Cancle_return_flow.css";
import Common_Back_Btn from "../common_components/common_back_btn/Common_Back_Btn";
import Product_Image from "../product_details/product_image/Product_Image";
import Perfect_Partner from "../product_details/perfect_partner/Perfect_Partner";
import Product_Description from "../product_details/product_description/Product_Description";
import Product_track_details from "./product_track_details/Product_track_details";
import Common_breadcrumb from "../common_components/common_breadcrumb/Common_breadcrumb";

const Cancle_return_flow = () => {
     const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "ACCOUNT", link: "/luxury/account" },
    { label: "ALL ORDERS", link: "/luxury/all-orders" },
    { label: "ORDERED" },
  ];
  return (
    <section className="Product_Details">
      <div className="custom_container">
        <Common_breadcrumb items={breadcrumbItems} />

        <div className="row">
          <div className="col-xl-8">
            <div className="left_side">
              <Product_Image />

              <div className="hidden_product_descn">
                <Product_track_details />
              </div>

            
            </div>
          </div>
          <div className="col-xl-4">
            <div className="right_side">
              <Product_track_details />
            </div>
          </div>
        </div>

          <Perfect_Partner />
      </div>
    </section>
  );
};

export default Cancle_return_flow;
